export const moveTrackToGroup = (track, destinationGroup) => {
    if (track.group === destinationGroup) {
        return;
    }

    let groups = track.sequencerEngine.groups;
    groups.addToGroup(track, destinationGroup);
};
